<template>
    <div class="vuetable-filterbar col-md-12 step-filtrar">
        <div class="form-group">
            <b-container fluid>
                <b-row no-gutters>
                    <b-col sm="6" md="1">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="num_oc"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                N° OC
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="1">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="lote"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                Lote
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="6">
                        <multiselect
                            v-model="transportadora"
                            :options-limit="300"
                            :limit="2"
                            :limit-text="limitText"
                            :options="optionsTransportadora"
                            track-by="value"
                            label="label"
                            id="transportadora"
                            placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                            :searchable="true"
                            :loading="isLoadingTransportadora"
                            @search-change="searchTransportadora"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="4">
                        <multiselect
                            v-model="motorista"
                            :options-limit="300"
                            :limit="2"
                            :limit-text="limitText"
                            :options="optionsMotorista"
                            track-by="value"
                            label="label"
                            id="motorista"
                            placeholder="Motorista"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                            :searchable="true"
                        ></multiselect>
                    </b-col>
                </b-row>

                <b-row no-gutters class="m-t-5px">
                    <b-col sm="6" md="2">
                        <multiselect
                            v-model="status"
                            :options="optionsStatus"
                            track-by="value"
                            label="label"
                            :hide-selected="true"
                            id="status"
                            placeholder="Status"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2">
                        <multiselect
                            v-model="placa"
                            :options-limit="300"
                            :limit="2"
                            :limit-text="limitText"
                            :options="optionsPlaca"
                            track-by="value"
                            label="label"
                            id="placa"
                            placeholder="Placa"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                            :searchable="true"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Dt. Criação Inicial"
                            reset-button
                            v-model="dt_ini"
                            class="form-control"
                            :date-format-options="dateFormatOptions"
                        />
                    </b-col>

                    <b-col sm="6" md="2">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Dt. Criação Final"
                            reset-button
                            v-model="dt_fim"
                            class="form-control"
                            :date-format-options="dateFormatOptions"
                        />
                    </b-col>

                    <b-col sm="6" md="2">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Dt. Aprovação Inicial"
                            reset-button
                            v-model="dt_aprovacao_ini"
                            class="form-control"
                            :date-format-options="dateFormatOptions"
                        />
                    </b-col>

                    <b-col sm="6" md="2">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Dt. Aprovação Final"
                            reset-button
                            v-model="dt_aprovacao_fim"
                            class="form-control"
                            :date-format-options="dateFormatOptions"
                        />
                    </b-col>
                </b-row>

                <b-row no-gutters class="m-t-5px">
                    <b-col sm="6" md="2">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Dt. Cancelamento Inicial"
                            reset-button
                            v-model="dt_cancelamento_ini"
                            class="form-control"
                            :date-format-options="dateFormatOptions"
                        />
                    </b-col>

                    <b-col sm="6" md="2">
                        <b-form-datepicker
                            locale="pt-br"
                            placeholder="Dt. Cancelamento Final"
                            reset-button
                            v-model="dt_cancelamento_fim"
                            class="form-control"
                            :date-format-options="dateFormatOptions"
                        />
                    </b-col>

                    <b-col sm="6" md="8">
                        <div class="d-flex flex-row-reverse">
                            <div class="input-group-btn">
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn btn-secondary btn-outline"
                                        @click="doFilter"
                                        :disabled="vuetableFilterButton"
                                    >
                                        Filtrar
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-secondary btn-outline"
                                        @click="resetFilter"
                                        :disabled="vuetableFilterButton"
                                    >
                                        Limpar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            date_attributes: [
                { key: "today", highlight: true, dates: new Date() },
            ],
            dt_aprovacao_fim: "",
            dt_aprovacao_ini: "",
            dt_cancelamento_fim: "",
            dt_cancelamento_ini: "",
            dt_fim: "",
            dt_ini: "",
            isLoadingTransportadora: false,
            lote: "",
            motorista: null,
            motoristaSec: null,
            num_oc: "",
            optionsStatus: [],
            optionsMotorista: [],
            optionsPlaca: [],
            optionsTransportadora: [],
            placa: null,
            placaSec: null,
            placaTer: null,
            status: null,
            transportadora: null,
            data_filter: {},
            dateFormatOptions: {
                day: "numeric",
                month: "numeric",
                year: "numeric",
            },
            helpForm: new Form({
                statusRecord: [],
                params: [],
                search: "",
            }),
        };
    },
    mounted() {
        this.$events.$on("filter-reset", (e) => this.onFilterReset());
        this.popularFiltros();
    },
    methods: {
        doFilter() {
            this.$store.commit("setVuetableFilterButton", true);
            const motorista = this.motorista ? this.motorista.value : null;
            const placa = this.placa ? this.placa.value : null;
            const status = this.status ? this.status.value : null;
            const transportadora = this.transportadora
                ? this.transportadora.value
                : null;

            this.data_filter = {
                dt_aprovacao_fim: this.formatDateSubmit(this.dt_aprovacao_fim),
                dt_aprovacao_ini: this.formatDateSubmit(this.dt_aprovacao_ini),
                dt_cancelamento_fim: this.formatDateSubmit(
                    this.dt_cancelamento_fim
                ),
                dt_cancelamento_ini: this.formatDateSubmit(
                    this.dt_cancelamento_ini
                ),
                dt_fim: this.formatDateSubmit(this.dt_fim),
                dt_ini: this.formatDateSubmit(this.dt_ini),
                lote: this.lote,
                motorista,
                num_oc: this.num_oc,
                placa,
                status,
                transportadora,
            };
            this.$events.fire("filter-set", this.data_filter);
        },
        onFilterReset() {
            this.dt_aprovacao_fim = "";
            this.dt_aprovacao_ini = "";
            this.dt_cancelamento_fim = "";
            this.dt_cancelamento_ini = "";
            this.dt_fim = moment().format("YYYY-MM-DD");
            this.dt_ini = moment()
                .subtract(1, "week")
                .format("YYYY-MM-DD");
            this.lote = "";
            this.motorista = null;
            this.num_oc = "";
            this.placa = null;
            this.status = null;
            this.transportadora = null;
            this.doFilter();
        },
        resetFilter() {
            this.onFilterReset();
        },
        popularFiltros() {
            this.optionsMotorista = [];
            this.optionsPlaca = [];
            this.dt_ini = moment()
                .subtract(1, "week")
                .format("YYYY-MM-DD");
            this.dt_fim = moment().format("YYYY-MM-DD");
            this.helpForm
                .get("/api/ordemcoleta/jsonlistfilters")
                .then((response) => {
                    new ReturnApi(response, this, true, false, false);
                    response.status.forEach((obj) => {
                        this.optionsStatus.push({
                            label: obj.descr,
                            value: obj.valor,
                        });
                    });
                    response.veiculo.forEach((veiculo) => {
                        this.optionsPlaca.push({
                            label: veiculo.placa,
                            value: veiculo.placa,
                        });
                        veiculo.veiculo_motorista.forEach((vm) => {
                            const pm = vm.pessoa_motorista;
                            if (pm) {
                                const pessoa = pm.pessoa_fisica;
                                if (pessoa) {
                                    this.optionsMotorista.push({
                                        label: `${pessoa.nome} - ${pessoa.cpf}`,
                                        value: vm.veimot_id,
                                    });
                                }
                            }
                        });
                    });
                })
                .catch((errors) => {
                    new ReturnApi(errors, this);
                });
        },
        formatDateSubmit(value, fmt = "DD/MM/YYYY") {
            return value == null || value == ""
                ? ""
                : moment(value, "YYYY-MM-DD").format(fmt);
        },
        limitText(count) {
            return `e ${count} outros`;
        },
        searchTransportadora(search) {
            if (search.length >= 3) {
                this.isLoadingTransportadora = true;
                this.helpForm.search = search;
                this.helpForm.status = 1;
                this.helpForm
                    .post("/api/pessoa/jsonlist/transportadora")
                    .then((response) => {
                        this.optionsTransportadora = [];
                        if (response.items.length > 0) {
                            response.items.forEach((obj) => {
                                this.optionsTransportadora.push({
                                    label:
                                        "PJ -" +
                                        obj.pessoa.cd +
                                        " - " +
                                        obj.razao_social +
                                        " - " +
                                        this.onFormataCnpj(obj.cnpj) +
                                        " - " +
                                        obj.inscricao_estadual,
                                    value: obj.pessoa_id,
                                    valida_opentech: obj.pessoa.valida_opentech,
                                });
                            });
                        }
                        if (response.itemsE.length > 0) {
                            response.itemsE.forEach((obj) => {
                                this.optionsTransportadora.push({
                                    label: "PE -" + obj.nome + " - " + obj.cd,
                                    value: obj.pessoa_id,
                                    valida_opentech: obj.pessoa.valida_opentech,
                                });
                            });
                        }
                        this.isLoadingTransportadora = false;
                    })
                    .catch((errors) => {
                        new ReturnApi(errors, this);
                    });
            }
        },
        onFormataCnpj(cnpj) {
            if (cnpj.length === 14) {
                return cnpj.replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    "$1.$2.$3/$4-$5"
                );
            } else {
                return cnpj;
            }
        },
    },
    computed: {
        vuetableFilterButton: {
            get() {
                return this.$store.state.vuetable.filterButton;
            },
        },
    },
};
</script>
